const createVoucherES = {
    key: 'Clave',
    productId: 'ID del producto',
    variantId: 'ID de variante',
    licenseId: 'ID de licencia',
    maxSessions: 'Usos máximos',
    generate: 'Generación de la clave'
}

export default createVoucherES